import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { downloadAirportService } from '../../actions/airportServices';
import { getCurrentAirportServices } from '../../selectors/airportServices';
import { getCurrentLegCrewType } from '../../selectors/screen';
import { FORM_CODES } from '../../service/constants';
import { getNoDataMessage } from './tools';

export const useAirportServicePage = () => {
    const airportServices = useSelector(getCurrentAirportServices);
    const currentLeg = useSelector((state) => state.screen?.currentLeg);
    const { allowEdit = false, allowDelete = false } = useSelector((state) =>
        get(state, `access[${FORM_CODES.AIRPORT_SERVICE_LIST_PLAN_FLIGHT}]`, {})
    );
    const crewType = useSelector(getCurrentLegCrewType);
    const noDataMessage = getNoDataMessage(crewType, airportServices);

    const dispatch = useDispatch();

    const handleDownloadService = useCallback(() => dispatch(downloadAirportService(currentLeg)), []);

    return {
        airportServices,
        allowEdit,
        allowDelete,
        currentLeg,
        noDataMessage,
        handleDownloadService,
    };
};
